import React, { Component } from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import EmployeeDragable from "./employeeDragable";
import { greyScaleColors, semanticColors } from "../../../Globals/styles";

class Employee extends Component {
  shouldComponentUpdate = (nextProps) => {
    const { employee, canDrag, index } = this.props;
    return (
      nextProps.employee.absence !== employee.absence ||
      nextProps.employee.break !== employee.break ||
      nextProps.employee.timeRegistrations !== employee.timeRegistrations ||
      nextProps.employee.shack !== employee.shack ||
      nextProps.employee.mileage !== employee.mileage ||
      nextProps.canDrag !== canDrag ||
      nextProps.index !== index
    );
  };
  getEmployeeHours = () => {
    const {
      employee: { timeRegistrations },
    } = this.props;
    let totalHours = 0;
    timeRegistrations.forEach((t) => {
      if (t.checkIn) {
        totalHours += t.hours;
      } else {
        totalHours += t.hours + t.nightHours;
      }
    });
    if (this.props.employee.break > 0) {
      totalHours -= this.props.employee.break;
    }
    return totalHours;
  };
  getButtonContent = () => {
    let totalHours = this.getEmployeeHours();
    if (this.props.employee.absence != null && totalHours === 0) {
      return (
        <i
          className="fa fa-calendar-times-o"
          style={styles.absenceIcon}
          aria-hidden="true"
        ></i>
      );
    }
    return totalHours;
  };
  isEmployeeActive = () => {
    const {
      employee: { absence, shack, mileage },
    } = this.props;
    let totalHours = this.getEmployeeHours();
    return absence != null || totalHours !== 0 || shack || mileage !== 0;
  };
  render() {
    const {
      employee,
      index,
      setEmployeeIsDragging,
      canDrag,
      disabled,
      rmEmployeeFromProject,
    } = this.props;
    if (!canDrag && !this.isEmployeeActive()) {
      return null;
    }
    return (
      <div style={styles.container}>
        <div>
          <div
            className="col-xs-10 waves-btn"
            style={[styles.employeeName, !canDrag && styles.employeeCantDrag]}
          >
            {canDrag ? (
              <EmployeeDragable
                employee={employee}
                index={index}
                getButtonContent={this.getButtonContent}
                setEmployeeIsDragging={setEmployeeIsDragging}
                onClick={() => rmEmployeeFromProject(index, employee.id)}
              />
            ) : null}

            {employee.name}
          </div>
          <div className="col-xs-2" style={[styles.hourButtonContainer]}>
            <button
              style={[
                styles.button,
                this.isEmployeeActive() && styles.employeeIsActive,
              ]}
              className="btn btn-default btn-block"
            >
              {disabled ? (
                <i className="fa fa-thumbs-down"></i>
              ) : (
                this.getButtonContent()
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

var styles = {
  container: {
    textAlign: "center",
    lineHeight: "35px",
    cursor: "pointer",
  },
  absenceIcon: {
    fontSize: "18",
  },
  employeeName: {
    textAlign: "left",
    marginTop: "12px",
    padding: "0 5px 0 40px",
    backgroundColor: greyScaleColors.greyLighter,
    height: "40px",
    lineHeight: "40px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    borderTopLeftRadius: "2px",
    borderTopRightRadius: "0px",
    borderBottomRightRadius: "0px",
    borderBottomLeftRadius: "2px",
  },
  employeeCantDrag: {
    padding: "0 5px 0 10px",
  },
  hourButtonContainer: {
    padding: "0",
    marginTop: "12px",
  },
  button: {
    height: "40px",
    padding: "0",
    borderTopLeftRadius: "0",
    borderBottomLeftRadius: "0",
    borderTopRightRadius: "2px",
    borderBottomRightRadius: "2px",
    backgroundColor: greyScaleColors.greyLighter,
    borderLeft: "1px solid " + semanticColors.mainBackground,
  },
  employeeIsActive: {
    backgroundColor: semanticColors.info,
    color: "#fff",
    borderLeft: "1px solid " + semanticColors.info,
  },
};
Employee.propTypes = {
  employee: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    absence: PropTypes.shape({
      date: PropTypes.object.isRequired,
      hours: PropTypes.number.isRequired,
      absenceCode: PropTypes.string,
    }),
    shack: PropTypes.bool.isRequired,
    mileage: PropTypes.number.isRequired,
    break: PropTypes.number,
    timeRegistrations: PropTypes.arrayOf(
      PropTypes.shape({
        hours: PropTypes.number.isRequired,
        nightHours: PropTypes.number.isRequired,
        employeeFunction: PropTypes.string,
      })
    ).isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  setEmployeeIsDragging: PropTypes.func.isRequired,
  canDrag: PropTypes.bool.isRequired,
};
export default Radium(Employee);



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/employee.jsx